import { useMemo } from 'react';
import { useMutationState } from '@tanstack/react-query';

import { getUpdateGroupsAdministrationMutationOptions, getUpdateUsersAdministrationMutationOptions } from '@/modules/api/codegen';

import { UserAdministrationType } from '../../../constants';

export const useIsTableDataLoading = (queryLoading: boolean, type: UserAdministrationType) => {
    const isUpdatingUsers =
        useMutationState({
            filters: { mutationKey: getUpdateUsersAdministrationMutationOptions().mutationKey, status: 'pending' },
        }).length > 0;

    const isUpdatingGroups =
        useMutationState({
            filters: { mutationKey: getUpdateGroupsAdministrationMutationOptions().mutationKey, status: 'pending' },
        }).length > 0;

    const isLoading = useMemo(() => {
        if (queryLoading) return true;

        if (type === UserAdministrationType.Users) return isUpdatingUsers;
        if (type === UserAdministrationType.Groups) return isUpdatingGroups;

        return false;
    }, [queryLoading, isUpdatingUsers, isUpdatingGroups, type]);

    return isLoading;
};
